var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 13.6668V1.66683C0.333984 1.30016 0.46454 0.986274 0.725651 0.725163C0.986762 0.464052 1.30065 0.333496 1.66732 0.333496H12.334C12.7007 0.333496 13.0145 0.464052 13.2757 0.725163C13.5368 0.986274 13.6673 1.30016 13.6673 1.66683V5.66683H12.334V1.66683H1.66732V10.4168L2.43398 9.66683H9.00065V11.0002H3.00065L0.333984 13.6668ZM11.6673 14.3335V11.0002H10.334V7.00016H13.6673L12.534 9.66683H14.0007L11.6673 14.3335Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.c3bba6f8ce7ae54669ee2ad7b4d7c56c.svg";
export { ForwardRef as ReactComponent };